export const RANKING_LIST_DAY_RANGE = 7;
export const RANKING_LIST_LIMIT = 30;
export const NEW_TEAMS_CREATED_AT_DAYS = 30;
export const NEW_TEAMS_PAGE_SIZE = 20;
export const CUSTOM_MODELS_PAGE_SIZE = 20;
